// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12zAw","col":"styles_col__1sfLu","actions":"styles_actions__1mM7a","conflict":"styles_conflict__3r0Bo"};